import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  clearUserSession,
  getUserSession,
  isProfileComplete,
  isValidSession,
  mergeSessionUser,
} from '../../services/authService';
import { fetchUserProfile } from '../../services/profileService';

const PUBLIC_PATHS = [
  '/iniciar-sesion',
  '/registro',
  '/registro/crear-cuenta',
  '/recuperar-contraseña',
  '/recuperar-contraseña/restablecer',
  '/completar-perfil',
  '/perfil',
  '/perfil/hijos',
  '/perfil/pacientes',
  '/perfil/notificaciones',
  '/perfil/cambiar-contraseña',
  '/perfil/planes',
  '/perfil/idioma',
  '/perfil/terminos',
  '/perfil/privacidad',
  '/perfil/ficha',
  '/perfil/reseña-profesional',
];

const isPublicPath = (pathname) => PUBLIC_PATHS.some((path) => pathname.startsWith(path));

const ProfileCompletenessGuard = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      const session = getUserSession();

      if (session && !isValidSession(session)) {
        clearUserSession();
        if (!cancelled) {
          setReady(true);
        }
        return;
      }

      if (!session?.id || session.perfil_completo !== false) {
        if (!cancelled) {
          setReady(true);
        }
        return;
      }

      try {
        const profile = await fetchUserProfile(session.id);
        if (cancelled) {
          return;
        }

        mergeSessionUser({
          perfil_completo: profile.perfil_completo,
          campos_faltantes: profile.campos_faltantes || [],
        });
      } catch (error) {
        // Si la API falla, no bloquear toda la app.
      } finally {
        if (!cancelled) {
          setReady(true);
        }
      }
    };

    bootstrap();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!ready) {
      return;
    }

    const session = getUserSession();

    const agendaDelEspecialista =
      session &&
      session.tipo === 'especialista' &&
      location.pathname.indexOf('/agenda') === 0;
    const regresoPago = location.pathname.indexOf('/agenda/regreso-pago') === 0
      || location.pathname.indexOf('/agenda/recibo') === 0;

    if (
      session &&
      isValidSession(session) &&
      !isProfileComplete(session) &&
      !isPublicPath(location.pathname) &&
      !agendaDelEspecialista &&
      !regresoPago
    ) {
      history.replace('/perfil');
    }
  }, [ready, history, location.pathname]);

  if (!ready) {
    return (
      <div className="app-bootstrap-loading" role="status" aria-live="polite">
        Cargando…
      </div>
    );
  }

  return children;
};

export default ProfileCompletenessGuard;
